import { useState, useCallback, useRef } from "react";
import { notification } from "antd";
import { postAffectationDemande } from "../../../../../services/charroiService";

export function useAffectationSubmit({ onSuccess } = {}) {
    const [submitting, setSubmitting] = useState(false);

    // Ref pour empêcher les doubles soumissions rapides (double-clic, Entrée x2)
    // même si le state React n'est pas encore mis à jour.
    const inFlightRef = useRef(false);

    const submit = useCallback(async ({ payload }) => {
        // === Protection anti double-soumission ===
        // Si une requête est déjà en cours, on ignore l'appel.
        if (inFlightRef.current) {
            console.warn("useAffectationSubmit: soumission déjà en cours, ignoré");
            return { ok: false, error: "Soumission déjà en cours", skipped: true };
        }

        inFlightRef.current = true;
        setSubmitting(true);

        try {
            const response = await postAffectationDemande(payload);

            notification.success({
                message: "Succès",
                description: "Affectation a été créée avec succès."
            });

            onSuccess?.();

            return {
                ok: true,
                id: response.data?.id_affectation
            }
        } catch (error) {
            console.error("useAffectationSubmit.submit", error);

            // Gestion des erreurs métier renvoyées par le backend
            const status = error?.response?.status;
            const serverMessage = error?.response?.data?.error;

            // 409 = conflit (doublon, demande verrouillée, véhicule indispo)
            if (status === 409 && serverMessage) {
                notification.warning({
                    message: "Affectation impossible",
                    description: serverMessage,
                    duration: 6,
                });
            } else {
                notification.error({
                    message: "Erreur",
                    description: serverMessage || "Échec de l'opération.",
                });
            }

            return { ok: false, error };
        } finally {
            inFlightRef.current = false;
            setSubmitting(false);
        }
    }, [onSuccess]);

    return { submitting, submit };
}